import { createRoot } from 'react-dom/client'
import './styles/base.css'
import { App } from './App'

const root = document.getElementById('root')
if (!root) throw new Error('Elemen #root tidak ditemukan')

createRoot(root).render(<App />)

/*
 * Pendaftaran service worker.
 *
 * Tanpa baris ini, seluruh isi sw.js adalah kode mati: aplikasi yang dipasang
 * di ponsel hanyalah pintasan layar utama, tidak ada mode luring, dan bundel
 * diunduh ulang dari jaringan setiap kali dibuka.
 *
 * Didaftarkan dari sini, bukan dari HTML statis, supaya ikut proses build dan
 * tidak terlewat saat berkasnya berubah.
 */
if ('serviceWorker' in navigator) {
  const daftarkan = () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((err: unknown) => {
      // Pendaftaran bisa ditolak pada konteks tertentu — mode privat, izin
      // dimatikan, atau halaman sedang berada di origin lain. Aplikasi tetap
      // berjalan penuh tanpanya, hanya kehilangan kemampuan luring.
      console.warn('Service worker tidak dapat didaftarkan:', err)
    })
  }

  // Menunggu event 'load' saja tidak cukup: bila modul ini baru dieksekusi
  // setelah load terlanjur lewat, pendengarnya tidak akan pernah terpicu.
  if (document.readyState === 'complete') daftarkan()
  else window.addEventListener('load', daftarkan, { once: true })
}
